const hoverQuery = window.matchMedia('(min-width: 750px) and (hover: hover) and (pointer: fine)');
const records = new WeakMap();
let active = null;
let frame = 0;

function reset() {
  if (frame) cancelAnimationFrame(frame);
  frame = 0;
  active?.overlay.classList.remove('is-active');
  active = null;
}

function containerFor(target) {
  if (!(target instanceof Element) || target.closest('dialog')) return null;
  const container = target.closest('.product-media-container--image');
  return container?.closest('media-gallery[data-cloud-hover-zoom]') ? container : null;
}

function render() {
  frame = 0;
  if (!active) return;
  if (!hoverQuery.matches || !active.container.isConnected) return reset();
  const { surface, overlay, x, y, ready } = active;
  const bounds = surface.getBoundingClientRect();
  if (!bounds.width || !bounds.height || x < bounds.left || x > bounds.right || y < bounds.top || y > bounds.bottom) {
    return reset();
  }
  const originX = Math.max(0, Math.min(100, ((x - bounds.left) / bounds.width) * 100));
  const originY = Math.max(0, Math.min(100, ((y - bounds.top) / bounds.height) * 100));
  overlay.style.transformOrigin = `${originX}% ${originY}%`;
  overlay.classList.toggle('is-active', ready);
}

function schedule() {
  if (!frame) frame = requestAnimationFrame(render);
}

function recordFor(container) {
  const surface = container.querySelector(':scope > .product-media, :scope > .product-media-constraint-wrapper > .product-media');
  const image = surface?.querySelector(':scope > img.product-media__image');
  if (!(image instanceof HTMLImageElement)) return null;
  const source = image.getAttribute('data_max_resolution') || image.currentSrc || image.src;
  if (!source) return null;
  const existing = records.get(container);
  if (existing?.image === image && existing.source === source) return existing;
  existing?.overlay.remove();
  surface.querySelectorAll(':scope > .cloud-hover-zoom__image').forEach(element => element.remove());
  const overlay = new Image();
  overlay.className = 'cloud-hover-zoom__image';
  overlay.alt = '';
  overlay.setAttribute('aria-hidden', 'true');
  overlay.draggable = false;
  overlay.decoding = 'async';
  overlay.fetchPriority = 'low';
  const imageStyle = getComputedStyle(image);
  overlay.style.objectFit = imageStyle.objectFit;
  overlay.style.objectPosition = imageStyle.objectPosition;
  overlay.style.borderRadius = imageStyle.borderRadius;
  const record = { container, surface, image, overlay, source, ready: false, x: 0, y: 0 };
  records.set(container, record);
  surface.classList.add('cloud-hover-zoom__surface');
  overlay.onload = () => {
    record.ready = overlay.naturalWidth > 0;
    if (active === record) schedule();
  };
  overlay.onerror = () => {
    record.ready = false;
    if (active === record) reset();
  };
  surface.append(overlay);
  overlay.src = source;
  return record;
}

function move(event) {
  if (!hoverQuery.matches || event.pointerType !== 'mouse' || event.buttons) return reset();
  const container = containerFor(event.target);
  if (!container) return reset();
  if (active?.container !== container) {
    reset();
    active = recordFor(container);
  }
  if (!active) return;
  active.x = event.clientX;
  active.y = event.clientY;
  schedule();
}

document.addEventListener('pointerover', move, { passive: true });
document.addEventListener('pointermove', move, { passive: true });
document.addEventListener('pointerout', (event) => {
  if (active && (!(event.relatedTarget instanceof Node) || !active.container.contains(event.relatedTarget))) reset();
}, { passive: true });
document.addEventListener('pointerdown', (event) => {
  if (!hoverQuery.matches || !containerFor(event.target)) reset();
}, { capture: true, passive: true });
document.addEventListener('pointercancel', reset, { passive: true });
document.addEventListener('keydown', reset);
document.addEventListener('variant:update', reset);
document.addEventListener('shopify:section:unload', reset);
document.addEventListener('visibilitychange', reset);
window.addEventListener('scroll', reset, { capture: true, passive: true });
window.addEventListener('resize', reset, { passive: true });
window.addEventListener('blur', reset);
hoverQuery.addEventListener('change', reset);

